import React from 'react';
import { NAVIGATION_PLANS_NAV_ITEM_NUDGE_ID } from '@atlassian/jira-onboarding-core/src/constants.tsx';
import { OnboardingNudgeErrorBoundary } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/onboarding-nudge-error-boundary/index.tsx';
import type { QuickstartNudgeWrapperBaseProps } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/quickstart-nudge/types.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const NavigationPlansNavItemLazy = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-software-onboarding-navigation-plans-nudge" */ './index'
		).then((exportedModule) => exportedModule.NavigationPlansNavItemWrapperNudge),
	{
		ssr: false,
	},
);
export const NavigationPlansNavItemWrapperNudgeAsync = ({
	children,
	isInsideMenu,
}: QuickstartNudgeWrapperBaseProps) => (
	<OnboardingNudgeErrorBoundary
		id={NAVIGATION_PLANS_NAV_ITEM_NUDGE_ID}
		fallback={children}
		attributes={{
			nudgeId: NAVIGATION_PLANS_NAV_ITEM_NUDGE_ID,
		}}
	>
		<Placeholder name="software-onboarding-navigation-plans-nudge" fallback={<>{children}</>}>
			<NavigationPlansNavItemLazy
				nudgeId={NAVIGATION_PLANS_NAV_ITEM_NUDGE_ID}
				isInsideMenu={isInsideMenu}
			>
				{children}
			</NavigationPlansNavItemLazy>
		</Placeholder>
	</OnboardingNudgeErrorBoundary>
);
